// extracted by mini-css-extract-plugin
export default {"snapCanvas":"styles_snapCanvas__5UAjw","noGrid":"styles_noGrid__1InS-"};